<template>
  <div class="page-top-navs">
    <div class="item" :class="{ active: item?.id == current?.id }" v-for="(item, index) in list" :key="index" @click.stop="$emit('click', item, index)">
      <Icon name="checkmore" /><span :class="{ ffen: getLocalLangCode() != 'zh' }">{{item?.label}}</span>
    </div>
  </div>
</template>

<script setup>
  import { ref, onMounted, watch } from 'vue';
  import Icon from '@/components/icon/index.vue';
  import { getLocalLangCode } from '@/assets/lang/index';

  const props = defineProps({
    list: {
      type: Array,
      default: []
    },
    target: {
      type: Object,
      default: null
    }
  })

  const current = ref(null)
  const init = () => {
    current.value = props.target;
  }
  onMounted(() => {
    init()
  })
  watch(() => props.target, () => {
    console.log('props.target---', props.target)
    init()
  })

</script>

<style scoped lang="less">
  @import "index.less";
</style>
